import React from 'react';

import Layout from '../Layout';

const GrassLayout: React.FC = () => {
  return (
    <Layout class="grass"/>
  );
}

export default GrassLayout;